module.exports = __webpack_public_path__ + "img/聚学u-01 1@2x.047698a4.png";